
export default (arraySize: number, resultsPerPage: number) => {
  
  return (arraySize % resultsPerPage === 0) ? ((arraySize) / resultsPerPage) : Math.floor((arraySize) / resultsPerPage) + 1;
  
  // return (displayedPools.length % resultsPerPage === 0) ? ((displayedPools.length) / resultsPerPage) : Math.floor((displayedPools.length) / resultsPerPage) + 1;
}